<template lang="pug">
.main
  v-container.py-6(fluid)
    div.mx-auto(style="max-width:600px")
      .h5.textColor--text.px-4 Clinic Subscription
      div.px-4
        y-stepper.mb-8(v-if='step < 5' :currentStep='step' :steps='steps')
        v-window(v-model='step' touchless)
          v-window-item(:value='0')
            // =========================================================================================================
            //  1. Choose your plan
            // =========================================================================================================
            v-layout.pa-6(v-if='!planGroup')
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width='2' :size='50' color='primary' indeterminate)
            .contracts(v-else)
              v-card.pa-4.mb-4(
                outlined
                v-for='(contract, index) in contracts'
                :ripple='false'
                :key='contract.code'
                :style='contract.selected ? "border:2px solid var(--v-textColorAccent)" : "border:2px solid var(--v-basic300)"'
                :color='contract.data.extra_data[planVersion].recommended ? $vuetify.theme.themes[$theme].successT08 : $vuetify.theme.themes[$theme].basic600T08'
              )
                div(@click='selectContract(contract)')
                  .d-flex.align-center
                    .h5.textColor--text {{ contract.data.extra_data[planVersion].name }}
                    .ml-2(v-if='contract.selected')
                      v-avatar.my-auto(:color='$vuetify.theme.themes[$theme].textColorAccent' size=20)
                        eva-icon(name='checkmark-outline' :fill='$vuetify.theme.themes[$theme].basic100' width='18' height='18' style='margin-top: 3px; margin-left: 1px')
                    v-spacer
                    .h4.textColor--text.text-right(style='') {{ contract.data.original_price / 100 }}

                  v-row.mt-3(no-gutters)
                    v-col
                      .s1.success500--text(v-if='contract.data.extra_data[planVersion].recommended') Recommended for you!
                      .p1.primary500--text {{ contract.data.extra_data[planVersion].promo_text }}
                    v-col
                      .p2.primary400--text.text-right {{ contract.data.extra_data[planVersion].bill_line_1 }}
                      .p2.primary400--text.text-right(v-if='!clinicSubscription.value') {{ contract.data.extra_data[planVersion].bill_line_2 }}

          v-window-item(:value='1')
            // =========================================================================================================
            //  2. Select payment method
            // =========================================================================================================
            .h5.textColor--text.text-center Select payment method
            v-card.mt-8(flat outlined style='border: 1px solid var(--v-basic300)')
              v-radio-group.mt-n1(v-model='selectedPaymentMethod' hide-details)
                v-layout(style='cursor: pointer' @click='selectedPaymentMethod = "card"')
                  v-layout.mt-1(style='height: 56px; max-width: 56px; min-width: 56px')
                    eva-icon.ma-auto(name='credit-card-outline' width='24' height='24' :fill='$vuetify.theme.themes[$theme].basic700')
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      .my-auto.pr-2
                        .s1.basic800--text Credit or debit card
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value='card' readonly)
                v-divider.basic300
                template(v-if='selectedContract')
                  v-layout(:style='selectedContract.data.billing_cycle === "monthly" ? "cursor: default" : "cursor: pointer"' @click='selectedContract.data.billing_cycle === "monthly" ? "" : (selectedPaymentMethod = "fpx")')
                    v-layout.mt-1(style='height: 56px; max-width: 56px; min-width: 56px')
                      BuildingBankIcon.ma-auto(size='24' :style='selectedContract.data.billing_cycle === "yearly" ? "color: var(--v-basic700)" : "color: var(--v-basic500)"')
                    v-col.pa-0.my-auto
                      v-layout.py-4
                        .my-auto.pr-2
                          .s1(:class='selectedContract.data.billing_cycle === "yearly" ? "basic800--text" : "basic500--text"') Online banking
                          .c1.basic500--text(v-if='selectedContract.data.billing_cycle === "monthly"') For yearly contract only
                    v-col.pa-0.shrink.mt-5
                      v-radio.my-0.py-0.mr-2(value='fpx' readonly)

            v-card.pa-4.mt-8(v-if='selectedPaymentMethod' flat outlined style='border: 1px solid var(--v-basic300)' :class="$vuetify.breakpoint.xsOnly ? 'my-10' : ''")
              card-list.mt-4(v-if='selectedPaymentMethod === "card"' @change='form.card = $event.id')
              .online-payment.mt-4(v-else-if='selectedPaymentMethod === "fpx"')
                .subtitle.mb-3 Choose bank for payment
                v-card.mb-5.scroll(:height="$vuetify.breakpoint.xsOnly ? '': '40vh'")
                  FPXPicker(v-model='fpxBankCode')
          v-window-item.text-center.mb-5(v-if='selectedContract' :value='2')
            // =========================================================================================================
            //  3. Confirm your subscription
            // =========================================================================================================
            .h5.textColor--text.text-center.mb-8 Confirm your subscription
            .h3.mt-6.textColor--text Clinic {{ selectedContract.data.billing_cycle | capitalize }}
            .h1.text-center.mt-4 {{ selectedContract.data.price / 100 }}
            .p1.primary400--text.mt-4 RM per {{ selectedContract.data.billing_cycle.replace("ly", "") }} with {{ selectedContract.data.billing_cycle }} contract
            .p2.text-center.success500--text.mt-2(v-if='selectedContract.data.confirm_promo_description') {{ selectedContract.data.confirm_promo_description }}

            .extra.mt-4(v-if='addOn.selected' v-for='(addOn, index) in selectedContract.data.add_ons' :key='"confirmation" + addOn.id')
              .s1.textColor--text + {{ addOn.feature.name }}
              .p1.primary400--text
                span (RM{{ addOn.price / 100 }} per {{ selectedContract.data.billing_cycle.replace("ly", "") }}, billed {{ selectedContract.data.billing_cycle }})

          v-window-item(:value='3')
            // =========================================================================================================
            //  4. Thank you
            // =========================================================================================================
            .h5.textColor--text.mb-8.text-center Subscription successful!
            v-container.text-center
              .p1.primary400--text Thank you for giving us the opportunity to help you grow further and bigger.
              .p1.primary400--text.mt-4 Let’s do this together.
              v-btn.mt-4(color='info500' dark @click="redirectToDashboard" depressed height=32)
                .button-AA-medium.basic100--text FINISH
          v-window-item(:value='5')
            // =========================================================================================================
            //  4. Payment failed
            // =========================================================================================================
            .h5.textColor--text.mb-8.text-center Payment failed
            v-container.text-center
              .p1.primary400--text The payment did not go through, please try again.
              v-btn.mt-4(color='info500' dark @click='retryPayment' depressed height=32)
                .button-AA-medium.basic100--text Retry Payment

      div(:class="$vuetify.breakpoint.xsOnly ? 'fixed-bottom full-width pr-5': ''")
        v-divider.basic300(v-if='step == 0')
        v-card-actions.basic200(v-if='step == 0 && selectedContract')
          v-col.pa-0
            .s2.primary400--text Selected plan:
            v-layout
              .p2.textColor--text {{ selectedContract.data.billing_cycle | capitalize }} contract
              v-spacer
              .p2.textColor--text {{ selectedContract.data.price | displayPriceRM }}
            v-layout(v-if='addOn.selected' v-for='(addOn, index) in selectedContract.data.add_ons' :key='"selected" + addOn.id')
              .p2.textColor--text + {{ addOn.feature.name }}
              v-spacer
              .p2.textColor--text {{ addOn.price | displayPriceRM }}
        v-divider.basic400(v-if='step == 0')
        v-card-actions.basic100(:class='step == 0 ? "basic200" : ""' v-if='steps[step].primaryButton')
          v-spacer
          v-btn(v-if='step > 0' color='white' text @click='previousStep')
            .button-Aa-medium.primary400--text {{ steps[step].secondaryButton }}
          v-btn(color='info500' @click='nextStep' depressed height=40 :loading='isLoading' :disabled='steps[step].disabled')
            .button-AA-medium.basic100--text {{ steps[step].primaryButton }}
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'
import Cookies from 'js-cookie'

export default {
  name: 'SubscribeClinic',
  components: { CardList, FPXPicker },
  data() {
    return {
      json: {
        name: 'Monthly plan',
        recommended: false,
        promo_text: '',
        bill_line_1: 'RM per month',
        bill_line_2: '',
      },
      isFetching: false,
      step: 0,
      planGroup: null,
      planVersion: 'v1.0',
      contracts: [],
      selectedContract: null,
      form: {
        contract: null,
        card: null,
      },
      isLoading: false,
      selectedPaymentMethod: null,
      fpxBankCode: null,
      retryPaymentLoading: false,
      statistics: {
        sales: 0,
        potential_sales: 0,
        total_expenses: 0,
        biggest_expense_category: null,
        biggest_expense_amount: 0,
      },
      dialog: true,
    }
  },
  computed: {
    ...mapState('subscriptions', ['clinicTrial', 'clinicSubscription']),
    ...mapState('user', ['user']),
    ...mapGetters({ company: 'getCompany' }),
    baseDomain () {
      return process.env.VUE_APP_BASE_DOMAIN
    },
    authMember() {
      return this.$store.state.user.member
    },
    steps() {
      return [
        { title: 'Select plan', hidden: false, secondaryButton: 'Back', primaryButton: 'Next' },
        { title: 'Payment', hidden: false, secondaryButton: 'Back', primaryButton: 'Next', disabled: !this.selectedPaymentMethod ? true : this.selectedPaymentMethod === 'card' ? !this.form.card : !this.fpxBankCode },
        { title: 'Confirmation', hidden: false, secondaryButton: 'Back', primaryButton: 'confirm' },
        { title: 'Subscription Successful!', hidden: true, primaryButton: null },
        { title: 'Payment Unsuccessful', hidden: true, primaryButton: null },
      ]
    },
    totalPriceAmount() {
      if (!this.selectedContract) return 0
      let totalPrice = this.selectedContract.data.price
      this.selectedContract.data.add_ons.forEach(addOn => {
        if (addOn.selected) {
          totalPrice += addOn.price
        }
      })
      return totalPrice
    },
  },
  watch: {
    selectedContract(val) {
      if (val.data.billing_cycle === 'monthly' && this.selectedPaymentMethod == 'fpx') {
        this.selectedPaymentMethod = 'card'
      }
    },
  },
  async mounted() {
    if (!this.user) {
      this.$router.push('/')
      return
    }

    // Fetch current subscriptions and redirect to dashboard if already subscribed
    await this.fetchCurrentSubscriptions()
    this.checkSubscriptions()

    await this.fetchSubscriptionPlans()
    this.form.company = this.company.id

    if (this.paymentCallback) {
      if (this.paymentCallback.success) {
        this.step = 3
      } else {
        this.step = 4
      }
    }

    this.$axios
      .get(`/books/${this.company.slug}/statistics`)
      .then(resp => {
        this.statistics = resp.data
      })
      .catch(() => {})
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    selectContract(contract) {
      this.contracts.forEach(c => {
        if (c.data.code === contract.data.code) {
          c.selected = true
          this.selectedContract = c
        } else {
          c.selected = false
        }
      })
    },
    previousStep() {
      this.step--
    },
    nextStep() {
      if (this.step === this.steps.length - 1) return

      if (this.step === 1) {
        if (!this.selectedPaymentMethod) {
          this.showMessage(['error', 'Please select payment method'])
          return
        }
      }

      if (this.step === 2) {
        this.form.contract = this.selectedContract.data.code
        this.form.add_ons = []
        this.selectedContract.data.add_ons.forEach(addOns => {
          if (addOns.selected) {
            const item = {
              feature: addOns.feature.code,
              count: 1,
            }
            this.form.add_ons.push(item)
          }
        })
        this.isLoading = true
        this.$axios
          .post(`/subscription/subscriptions/${this.clinicTrial.data.id}/cancel/`, {})
          .catch(() => {})
          .finally(() => {
            if (this.selectedPaymentMethod === 'card') {
              this.subscribeByCard()
            } else if (this.selectedPaymentMethod === 'fpx') {
              this.subscribeByFpx()
            }
          })
      } else {
        this.step++
      }
    },
    subscribeByCard() {
      this.isLoading = true
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent,
      }
      this.$axios
        .post(`/subscription/subscriptions/`, this.form)
        .then(resp => {
          this.$axios
            .post(`/subscription/bills/${resp.data.bill}/charge_card/`, this.form)
            .then(() => {
              this.$emit('subscribed')
              this.fetchCompany()
              this.step++
            })
            .catch(() => {
              this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
            })
            .finally(() => {
              this.isLoading = false
            })
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
          this.isLoading = false
        })
    },
    subscribeByFpx() {
      this.isLoading = true
      if (this.company.currency.currency_code === 'IDR') {
        this.form.method = 'xendit'
      } else {
        this.form.method = 'laravel'
      }
      this.form.bank_code = this.fpxBankCode
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent,
      }
      this.$axios
        .post(`/subscription/subscriptions/`, this.form)
        .then(resp => {
          this.$axios
            .post(`/subscription/bills/${resp.data.bill}/request_manual_payment/`, this.form)
            .then(resp => {
              const data = resp.data
              setTimeout(() => {
                location.href = data.bill_url
              }, 1000)
            })
            .catch(() => {
              this.showMessage(['error', 'Unable to subscribe. Please try different method or contact our support team.'])
              this.isLoading = false
            })
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try different method or contact our support team.'])
          this.isLoading = false
        })
    },
    fetchCompany() {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios
          .get(`/companies/${this.company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      } else {
        this.$axios
          .get(`/companies/${this.$subdomain}/`, { params: { use_slug: 'true' } })
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      }
    },
    fetchCurrentSubscriptions () {
      return this.$axios.get(`/subscription/subscriptions/?company=${this.company.id}&terminated=false&ordering=start_date&expand=contract&page_size=1000`)
        .then((response) => {
          this.$store.commit('subscriptions/setSubscriptions', response.data.results)
          this.$store.commit('subscriptions/setDefaultFeature', this.company)
        },()=>{})
    },
    checkSubscriptions () {
      // Check if already subscribe to clinic
      if (this.clinicSubscription.value) {
        this.showMessage(['error', 'Already subscribed to clinic'])
        return this.redirectToDashboard()
      }
    },
    fetchSubscriptionPlans() {
      this.isFetching = true
      this.$axios
        .get(`/subscription/plan_groups/YCLINIC`)
        .then(resp => {
          this.planGroup = resp.data
          const plansStructure = this.planGroup.extra_data[this.planVersion]
          this.contracts = []
          plansStructure.forEach(structure => {
            this.planGroup.plans.forEach(plan => {
              plan.contracts.forEach(contract => {
                if (structure.code === contract.code) {
                  const newContract = {
                    selected: false,
                    data: contract,
                  }
                  if (contract.extra_data.launch_promo_discount && !this.clinicSubscription.value) {
                    newContract.data.original_price = newContract.data.price
                    newContract.data.price = newContract.data.original_price - contract.extra_data.launch_promo_discount.discount_amount
                    newContract.data.confirm_promo_description = contract.extra_data.launch_promo_discount.description
                  } else {
                    newContract.data.original_price = newContract.data.price
                  }
                  this.contracts.push(newContract)
                }
              })
            })
          })
          this.contracts[0].selected = true
          this.selectedContract = this.contracts[0]
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    retryPayment() {
      this.retryPaymentLoading = true
      location.href = `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.paymentCallback.billId}?auto_submit=true`
    },
    redirectToDashboard() {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        document.location.href = `http://${window.location.host}/admin/clinic/appointment`
      } else {
        document.location.href = `https://${this.company.slug}.${this.baseDomain}/admin/clinic/appointment`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.v-card.payment-method-selected {
  border-color: #d11184;
}

.separator {
  position: absolute;
  height: 2px;
  top: 38px;
  left: 0px;
  right: 0px;
}

.scroll {
  overflow-y: scroll;
}

.fixed-bottom {
  position: fixed;
  bottom: 0;
}

.full-width {
  width: 100%;
}
</style>
